// const VERCEL_URL = 'https://golf-balls-27u35g9do-anooas-projects.vercel.app/api';
const VERCEL_URL =
  "https://golf-balls-m3c4otpar-anooas-projects.vercel.app/api";
const OPENCAGE_API_KEY = "487d8f9681e6489e92ea1742ad3b6e66";
Cesium.Ion.defaultAccessToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0MzVjZTJiMi05ODYyLTQ0YzAtYWM3Yy05ODNjM2VmZTMwZDMiLCJpZCI6MjQ3NDQ4LCJpYXQiOjE3Mjg2NjQwNzJ9.wiDyRl15mIXnOdNHVu8v99J7coYoPMmTk8POoStFVl0";
let map;
let allCourses = []; // Array to store all fetched golf courses
const STATE_NAME_TO_CODE = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
  
  // Canada Provinces and Territories
  Alberta: "AB",
  "British Columbia": "BC",
  Manitoba: "MB",
  "New Brunswick": "NB",
  "Newfoundland and Labrador": "NL",
  "Northwest Territories": "NT",
  "Nova Scotia": "NS",
  Ontario: "ON",
  "Prince Edward Island": "PE",
  Quebec: "QC",
  Saskatchewan: "SK",
  Yukon: "YT",
  "Nunavut": "NU"
};


async function getLocationDetailsFromCoordinates(latitude, longitude) {
  try {
    const response = await fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${OPENCAGE_API_KEY}`
    );
    if (!response.ok) throw new Error("Failed to fetch location details");

    const data = await response.json();
    const components = data.results[0]?.components || {};
    let stateName = components.state || null;
    let stateCode = stateName ? STATE_NAME_TO_CODE[stateName] : null;

    console.log("stateName:", stateName);
    console.log("stateCode:", stateCode);

    // If stateName or stateCode is null, default to "New York" and "NY"
    if (!stateName || !stateCode) {
      stateName = "New York";
      stateCode = "NY";
    }

    console.log("stateName:", stateName);
    console.log("stateCode:", stateCode);

    // Return city and state code (defaulting to New York and NY if not found)
    return {
      city: components.city || components.town || components.village || null, // Check for other city-like fields
      state: stateCode,
    };
  } catch (error) {
    console.error("Failed to fetch location details from coordinates:", error);

    // If there's an error, return default state as "New York" and "NY"
    return {
      city: "New York",
      state: "NY",
      stateCode: "NY",
    };
  }
}


async function fetchCoursesForLocation(stateName, cityName) {
  try {
    // Send both state and city in the request
    const response = await fetch(
      `${VERCEL_URL}/fetch-cities?state=${encodeURIComponent(
        stateName
      )}&city=${encodeURIComponent(cityName)}`
    );

    if (!response.ok)
      throw new Error(
        `Failed to fetch courses for location: ${response.statusText}`
      );

    const data = await response.json();
    // Check if results property exists and is an array
    if (!data || !Array.isArray(data.results)) {
      throw new Error("Invalid data structure: results array not found");
    }

    // Normalize input city for comparison
    const normalizedCityName = cityName.toLowerCase().trim();

    // Filter the courses based on the city
    const filteredCourses = data.results.filter((course) => {
      const courseCity = course.City?.toLowerCase().trim();
      return courseCity === normalizedCityName;
    });

    return filteredCourses;
  } catch (error) {
    console.error("Error fetching courses for location:", error);
    return [];
  }
}

let viewer;

function initMap(latitude, longitude) {
  if (!viewer) {
    viewer = new Cesium.Viewer("map", {
      imageryProvider: new Cesium.UrlTemplateImageryProvider({
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        maximumLevel: 19,
      }),

      baseLayerPicker: false, // Disable the base layer picker
      terrainProvider: new Cesium.EllipsoidTerrainProvider(), // Use basic ellipsoid terrain (no token required)
    });

    // Set the initial view (camera height set to 5000000 meters)
    const initialCameraPosition = Cesium.Cartesian3.fromDegrees(longitude, latitude, 29000000);
    viewer.scene.camera.setView({
      destination: initialCameraPosition,
    });

    // Set up min and max zoom (camera height limits)
    const minZoomHeight = 1000; // Minimum camera height in meters
    const maxZoomHeight = 50000000; // Maximum camera height in meters

    // Monitor camera movement and restrict zoom
    viewer.scene.camera.changed.addEventListener(function () {
      const cameraHeight = viewer.scene.camera.positionCartographic.height;

      // Ensure the camera height stays within the set limits
      if (cameraHeight < minZoomHeight) {
        viewer.scene.camera.positionCartographic.height = minZoomHeight;
      } else if (cameraHeight > maxZoomHeight) {
        viewer.scene.camera.positionCartographic.height = maxZoomHeight;
      }
    });

    // Set the camera's minimum zoom distance
    viewer.scene.screenSpaceCameraController.minimumZoomDistance = minZoomHeight; // Prevent zooming closer than minZoomHeight
  }
}



// Initialize the application
async function init() {
  if ("geolocation" in navigator) {
    console.log("Geolocation is available");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        await processLocation(latitude, longitude);
      },
      async (error) => {
        console.error("Error getting location:", error.message);
        // Use default coordinates if there's an error or permission is denied
        await processLocation(40.7128, -74.006);
      }
    );
  } else {
    console.error("Geolocation is not supported by this browser.");
  }
}

async function processLocation(latitude, longitude) {
  console.log("Latitude:", latitude);
  console.log("Longitude:", longitude);

  // Fetch location details based on coordinates
  let city = '';
  let state = '';

  try {
    const locationDetails = await getLocationDetailsFromCoordinates(latitude, longitude);
    city = locationDetails?.city || ''; // Safely access city and fallback to empty string
    state = locationDetails?.state || ''; // Safely access state and fallback to empty string
  } catch (error) {
    console.error("Error fetching location details:", error);
  }

  // If city and state are not found, default to New York
  if (!city || !state) {
    console.log("Failed to retrieve city and state from coordinates. Defaulting to New York.");
    city = "New York";
    state = "NY";
    latitude = 40.7128;  // New York's latitude
    longitude = -74.0060; // New York's longitude
  }

  console.log("City:", city);
  console.log("State code:", state);

  // Initialize the map at the given coordinates
  initMap(latitude, longitude);

  // Fetch golf courses for the location
  try {
    const locationCourses = await fetchCoursesForLocation(state, city);
    
    // If courses are found, update the popup with the courses
    if (locationCourses.length > 0) {
      updateCoursePopup(locationCourses);
    } else {
      console.log("No courses found for the location.");
    }
  } catch (error) {
    console.error("Error fetching golf courses:", error);
  }
}


// Display courses in the dropdown while avoiding duplicates
function updateCoursePopup(courses) {
  const dropdown = document.getElementById("course-popup");
  if (dropdown) {
    dropdown.innerHTML = ""; // Clear existing items

    if (Array.isArray(courses) && courses.length > 0) {
      courses.forEach((course) => {
        // Ensure course has necessary properties
        if (course.Name) {
          const courseItem = document.createElement("div");
          courseItem.className = "course-item";
          courseItem.textContent = course.Name; // Use Name property
          // Add click event listener
          courseItem.addEventListener("click", () => {
            const courseDetails = {
              name: course.Name,
              city: course.City,
            };
            selectCourse(courseDetails);
          });

          dropdown.appendChild(courseItem);
        } else {
          console.warn("Course object missing properties:", course);
        }
      });
    } else {
      console.log("No courses to display");
    }
  } else {
    console.error("Dropdown element not found");
  }
}

async function selectCourse(course) {
  // Use the city from the course object directly
  const city = course.city; // Assuming `course.city` contains the city name

  // Show the loading spinner
  const spinner = document.querySelector(".loading-overlay");
  spinner.style.display = "flex";

  try {
    // Fetch latitude and longitude from the geocoding API
    const geocodeResponse = await fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(
        city
      )}&key=${OPENCAGE_API_KEY}`
    );
    if (!geocodeResponse.ok)
      throw new Error("Failed to fetch location details");

    const geocodeData = await geocodeResponse.json();
    const { lat: latitude, lng: longitude } =
      geocodeData.results[0]?.geometry || {};

    if (!latitude || !longitude) {
      throw new Error("Location not found");
    }

    // Send data to the Vercel endpoint
    const response = await fetch(`${VERCEL_URL}/post-data`, {
      method: "POST",
      body: JSON.stringify({
        latitude: latitude,
        longitude: longitude,
        location_name: city,
        course: course.name,
        scan_time: new Date().toISOString(),
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (result.result === "success") {
      // Display success message
      const successContent = document.querySelector(".success-content");
      successContent.innerHTML = `Course '${course.name}' added successfully! Click to refresh the map.`;
      const successPopup = document.querySelector(".success-popup-container");
      successPopup.style.display = "flex";
      hideDropdown();
    } else {
      alert(`Failed to add the course. Please try again.`);
    }
  } catch (error) {
    console.error("Error sending data:", error);
    alert("Failed to add the course. Please try again.");
  } finally {
    // Hide the loading spinner
    spinner.style.display = "none";
  }
}

// Call the init function on script load
init();
const urlParams = new URLSearchParams(window.location.search);
const showBallPopup = urlParams.get("ball") === "true";

if (showBallPopup) {
  // document.getElementById("location-popup").style.display = "block";
  document.getElementById("location-popup").style.display = "none";
}

document.getElementById("agree-location").onclick = async () => {
  await handleLocationShare();
  document.getElementById("location-popup").style.display = "none";
  showDropdown();
};

document.getElementById("disagree-location").onclick = () => {
  document.getElementById("ball-count").style.display = "none";
  document.getElementById("location-popup").style.display = "none";
  const url = new URL(window.location);
  url.searchParams.delete("ball");
  window.history.replaceState({}, "", url);
};

const urlParamsa = new URLSearchParams(window.location.search);

if (showBallPopup) {
  // document.getElementById("location-popup").style.display = "block";
  document.getElementById("location-popup").style.display = "none";
}

async function handleLocationShare() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        // Initialize or update map view
        initMap(latitude, longitude);

        // Get country from coordinates
        const { city, state } = await getLocationDetailsFromCoordinates(
          latitude,
          longitude
        );
        if (state) {
        } else {
          console.error("Country not found.");
        }
      },
      (error) => {
        console.error("Error:", error.message);
        initMap(40.7128, -74.006);
      }
    );
  } else {
    alert("Geolocation is not supported by this browser.");
  }
}

document.querySelector(".cross-btn").addEventListener("click", function (e) {
  const url = new URL(window.location);
  url.searchParams.delete("ball");
  window.history.replaceState({}, "", url);

  const dropdown = document.querySelector(".course-popup-content");
  dropdown.style.display = "none"; // Hide the dropdown
});

function showDropdown() {
  const dropdown = document.querySelector(".course-popup-content");
  if (dropdown) {
    dropdown.style.display = "flex";
  }
}

function hideDropdown() {
  removeBallQuery();
  const dropdown = document.querySelector(".course-popup-content");
  if (dropdown) {
    dropdown.style.display = "none";
  }
}

// Function to remove ?ball=true from the URL
function removeBallQuery() {
  const url = new URL(window.location);
  url.searchParams.delete("ball");
  url.searchParams.set("count", "true");
  window.history.replaceState({}, "", url);
  const urlParams = new URLSearchParams(window.location.search);
  const showBallCount = urlParams.get("count") === "true";
  if (showBallCount) {
    const ballCountElement = document.getElementById("ball-count");
    if (ballCountElement) {
      ballCountElement.style.display = "block";
    }
  }
}

let currentPage = 1;
let totalPages;
const rowsPerPage = 10;

async function fetchTableData() {
  try {
    togglePaginationButtons(false);
    const response = await fetch(`${VERCEL_URL}/fetch-data`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const totalRows = data.length;

    const paginationElement = document.getElementById('pagination');
    if (paginationElement) {
      if (totalRows > 0) {
        paginationElement.style.display = "block";
      }
    }
    
    totalPages = Math.ceil(totalRows / rowsPerPage); // Remove const here

    updateBallCount(totalRows);
    populateTable(data, currentPage);
    addGolfCourseMarkers(data);
  } catch (error) {
    console.error("Failed to fetch table data:", error.message);
    // alert('Failed to load table data.');
  } finally {
    // Enable pagination buttons after fetch completes
    togglePaginationButtons(true);
  }
}


function addGolfCourseMarkers(courses) {
  const svgIcon =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="800px" height="800px" viewBox="0 0 395.71 395.71" xml:space="preserve">
      <g>
        <path d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738   c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388   C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191   c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z"/>
      </g>
    </svg>
  `);

  if (courses && Array.isArray(courses)) {
    courses.forEach((course) => {
      if (course.latitude && course.longitude && viewer) {
        // Create the marker (entity) with course name and location
        const entity = viewer.entities.add({
          position: Cesium.Cartesian3.fromDegrees(
            course.longitude,
            course.latitude
          ),
          billboard: {
            // Use the inline SVG as the icon
            image: svgIcon,
            width: 30, // Adjust the width
            height: 40, // Adjust the height
          },
          label: {
            text: course.course,
            font: "9pt monospace",
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            outlineWidth: 2,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            pixelOffset: new Cesium.Cartesian2(0, -35), // Offset label to avoid overlapping marker
            show: false, // Initially hide the label
          },
        });

        // Add click event listener to toggle label visibility
        viewer.screenSpaceEventHandler.setInputAction(function (click) {
          const pickedObject = viewer.scene.pick(click.position);
          if (Cesium.defined(pickedObject) && pickedObject.id === entity) {
            // Toggle label visibility
            entity.label.show = !entity.label.show;
          }
        }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
      }
    });
  } else {
    console.error("Invalid courses data:", courses);
  }
}

let paginatedData = [];

function populateTable(data, page) {
  const tableBody = document.querySelector("#data-table tbody");
  tableBody.innerHTML = ""; // Clear existing rows

  // Calculate the start and end indexes for slicing the data
  const start = (page - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const rowsToShow = data.slice(start, end);

  rowsToShow.forEach((item) => {
    const row = document.createElement("tr");

    const locationNameCell = document.createElement("td");
    locationNameCell.textContent = item.location_name || "N/A";
    row.appendChild(locationNameCell);

    const courseCell = document.createElement("td");
    courseCell.textContent = item.course || "N/A";
    row.appendChild(courseCell);

    const scanTimeCell = document.createElement("td");
    scanTimeCell.textContent = item.scan_time
      ? new Date(item.scan_time).toLocaleString()
      : "N/A";
    row.appendChild(scanTimeCell);

    tableBody.appendChild(row);
  });

  // Update pagination display
  document.getElementById("page-info").textContent = `Page ${page} of ${totalPages}`;
}

function updateBallCount(totalBalls) {
  const ballCountElement = document.getElementById("ball-count");

  if (ballCountElement) {
    ballCountElement.innerText = `Total Balls Scanned: ${totalBalls}`;

    const urlParamsqa = new URLSearchParams(window.location.search);
    const showBallCount = urlParamsqa.get("count") === "true";
    const showBallCountPopup = urlParams.get("ball") === "true";
    if (showBallCount || showBallCountPopup) {
      ballCountElement.style.display = "block";
    }
    // ballCountElement.style.display = totalBalls > 0 ? 'block' : 'none';
  } else {
    console.error("Ball count element not found.");
  }
}

// Call fetchTableData to populate the table when the page loads
document.addEventListener("DOMContentLoaded", fetchTableData);
let debounceTimeout;
const cache = {}; // Simple in-memory cache

document.getElementById("search-input").addEventListener("input", function () {
  const query = this.value;

  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }

  if (query.length < 2) {
    // Clear suggestions if query is too short
    document.getElementById("suggestions-list").innerHTML = "";
    return;
  }

  debounceTimeout = setTimeout(async () => {
    if (cache[query]) {
      // If query is cached, use the cached data
      displaySuggestions(cache[query]);
      return;
    }

    try {
      const response = await fetch(
        `${VERCEL_URL}/search?q=${encodeURIComponent(query)}`
      );
      if (!response.ok) {
        throw new Error("Error fetching search results");
      }
      const data = await response.json();

      // Cache the results
      cache[query] = data;

      displaySuggestions(data);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  }, 300); // Adjust delay as needed
});

function displaySuggestions(data) {
  const suggestionsList = document.getElementById("suggestions-list");
  suggestionsList.innerHTML = ""; // Clear existing suggestions

  data.forEach((item) => {
    const listItem = document.createElement("li");
    console.log("item:", item);
    // listItem.textContent = item.Name || item.name, item.Address;
    listItem.textContent = `${item.Name || item.name}, ${
      item.Address || item.address
    }`; // Adjust to match your data structure

    // Add click event listener for each suggestion
    listItem.addEventListener("click", () => {
      // Handle suggestion click, similar to course selection
      const selectedCourse = {
        name: item.Name || item.name,
        city: item.City || item.city, // Adjust based on your data structure
        lat: item.Latitude || item.latitude, // Adjust based on your data structure
        lon: item.Longitude || item.longitude, // Adjust based on your data structure
      };

      // Call the same selectCourse function as for the courses
      selectCourse(selectedCourse);
    });

    suggestionsList.appendChild(listItem);
  });
}

function togglePaginationButtons(enable) {
  document.getElementById("prevPage").disabled = !enable;
  document.getElementById("nextPage").disabled = !enable;
}

document.getElementById("prevPage").addEventListener("click", () => {
  if (currentPage > 1) {
    currentPage--;
    fetchTableData(); // Refresh data for current page
  }
});

document.getElementById("nextPage").addEventListener("click", () => {
  if (currentPage < totalPages) {
    currentPage++;
    fetchTableData(); // Refresh data for current page
  }
});

function goBack() {
  window.history.back();
}
